var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { SgdfElement } from '../../internal/sgdf-element.js';
import styles from './sidebar-item.styles.js';
let SgdfSidebarItem = class SgdfSidebarItem extends SgdfElement {
    constructor() {
        super(...arguments);
        /** Met l'item en surbrillance (page courante). */
        this.active = false;
    }
    render() {
        return html `
            <li
                class=${classMap({
            'sidebar-item': true,
            'sidebar-item--active': this.active,
        })}
            >
                <slot></slot>
            </li>
        `;
    }
};
SgdfSidebarItem.styles = styles;
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfSidebarItem.prototype, "active", void 0);
SgdfSidebarItem = __decorate([
    customElement('sgdf-sidebar-item')
], SgdfSidebarItem);
export { SgdfSidebarItem };
//# sourceMappingURL=sidebar-item.js.map